import React, { PropsWithRef, ReactNode } from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { BoxProps } from '@osmosis/tailwind-ui/components/Box';
import { bg100 } from '@osmosis/tailwind-ui/styles';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';

/**
 * A divider component.
 */
const Divider = ({
  isVertical,
  text,
  ...props
}: PropsWithRef<BoxProps> & {
  text?: ReactNode;
  isVertical?: boolean;
}): JSX.Element => (
  <Box cn="flex items-center gap-8">
    <Box
      {...props}
      cn={cn(
        isVertical ? 'h-full w-px' : 'h-px w-full',
        // eslint-disable-next-line @nx/workspace/tailwind-style-enforcement -- bg100 kept intentionally: bg1='bg-zinc-100' has no dark mode pair; would render as bright line in dark mode
        bg100,
        props.cn,
        props.className,
      )}
    />

    {!!text && (
      <>
        {text}
        <Box
          {...props}
          cn={cn(
            isVertical ? 'h-full w-px' : 'h-px w-full',
            // eslint-disable-next-line @nx/workspace/tailwind-style-enforcement -- bg100 kept intentionally: bg1='bg-zinc-100' has no dark mode pair; would render as bright line in dark mode
            bg100,
            props.cn,
            props.className,
          )}
        />
      </>
    )}
  </Box>
);

export default Divider;
